/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

import {
  faAt,
  faInputNumeric,
  faInputText,
  faLink,
  faMoneyCheckEdit,
  faPenSquare,
  faPhoneAlt,
  IconDefinition
} from '@fortawesome/pro-regular-svg-icons';
import { EPGImageSliderItem } from '../../../app/shared/epg-image-slider/epg-image-slider.component';
import { getImageSliderFromTaskDatum } from '../../../app/shared/functions';
import { TaskDataArray, TaskDataObject, TaskDatumModel } from '../../../models/task.model';
import {
  LocationModel,
  RecordBaseModel,
  WorkflowItemSubtype,
  WorkflowItemType
} from '../record-base.model';

export enum LinkType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  URL = 'URL'
}

export enum FormInputType {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  URL = 'URL'
}
export class InputRecord extends RecordBaseModel {
  itemIcon: IconDefinition = faPenSquare;
  itemData?: InputRecordData;

  constructor(itemName: string, geolocation?: LocationModel, timestamp?: string) {
    super(itemName, WorkflowItemType.FORM, WorkflowItemSubtype.INPUT, geolocation, timestamp);
  }

  fromJson(json: any): RecordBaseModel | undefined {
    if (!json) return;
    let record = new InputRecord(
      json.itemName.value,
      LocationModel.fromJson(json.geolocation),
      json.timestamp?.value
    );
    let inputRecordData = Object.create(InputRecordData.prototype);
    record.itemData = inputRecordData.fromJson(json);

    return record;
  }
}

export class InputRecordData {
  displayedText: string;
  label: string;
  inputValue: string;
  image?: EPGImageSliderItem;
  inputType: FormInputType;
  icon: IconDefinition;

  constructor(
    displayedText: string,
    label: string,
    inputValue: string,
    inputType: FormInputType,
    icon: IconDefinition,
    image?: EPGImageSliderItem
  ) {
    this.displayedText = displayedText;
    this.label = label;
    this.image = image;
    this.inputValue = inputValue;
    this.inputType = inputType;
    this.icon = icon;
  }

  fromJson(json: any): InputRecordData | undefined {
    let displayedText = '';
    let label = '';
    let inputValue = '';
    let inputType: FormInputType = FormInputType.TEXT;
    let icon!: IconDefinition;
    let image: EPGImageSliderItem | undefined;

    if (json.formData.type === 'ARRAY') {
      let taskDataArrayModel = Object.create(TaskDataArray.prototype);
      let taskDataArray = taskDataArrayModel.fromJson(json.formData) as TaskDataArray;
      for (const item of taskDataArray.value) {
        if (item instanceof TaskDataObject) {
          if (item.value.get('type')?.value === 'TEXT') {
            displayedText = item.value.get('text')?.value;
          }
          if (item.value.get('type')?.value === 'TEXTFIELD') {
            label = item.value.get('text')?.value;
            inputValue = item.value.get('value')?.value;
            inputType = getInputType(item.value.get('inputType')?.value ?? '');
            icon = getIcon(inputType);
          }
          if (item.value.get('type')?.value === 'IMAGE' && item.value.get('value')) {
            image = getImageSliderFromTaskDatum(item.value.get('value')!);
          }
        }
      }
    }

    return new InputRecordData(displayedText, label, inputValue, inputType, icon, image);
  }
}
export function getIcon(inputType: FormInputType): IconDefinition {
  switch (inputType) {
    case FormInputType.TEXT:
      return faInputText;
    case FormInputType.NUMBER:
      return faInputNumeric;

    case FormInputType.EMAIL:
      return faAt;

    case FormInputType.PHONE:
      return faPhoneAlt;

    case FormInputType.URL:
      return faLink;

    default:
      return faMoneyCheckEdit;
  }
}

export function getInputType(value: string): FormInputType {
  switch (value?.toUpperCase()) {
    case FormInputType.TEXT:
      return FormInputType.TEXT;

    case FormInputType.NUMBER:
      return FormInputType.NUMBER;

    case FormInputType.EMAIL:
      return FormInputType.EMAIL;

    case FormInputType.PHONE:
      return FormInputType.PHONE;

    case FormInputType.URL:
      return FormInputType.URL;

    default:
      return FormInputType.TEXT;
  }
}
export function getLinkType(inputType: FormInputType): LinkType | undefined {
  switch (inputType) {
    case FormInputType.EMAIL:
      return LinkType.EMAIL;

    case FormInputType.PHONE:
      return LinkType.PHONE;

    case FormInputType.URL:
      return LinkType.URL;

    default:
      return undefined;
  }
}
